import { render, staticRenderFns } from "./SignaturesReceptions.vue?vue&type=template&id=7c0ead0a&"
import script from "./SignaturesReceptions.vue?vue&type=script&lang=js&"
export * from "./SignaturesReceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports